import * as environmentService from './environment.service';

export default environmentService;
